import { Card, Flex, Separator, Typography, theme } from '@fe-toolkit/web-components/ssr'

import Image from '@/components/atoms/Image'

import { convertMbpsToGbps } from '@/utils/convertMbpsToGbps'
import { OrderDetail } from '@/api'

import { ImagePaddingWrapper } from '../../ImagePaddingWrapper.styled'

export type OrderTotalProps = {
  orderData: OrderDetail | undefined
}

const OrderTotalCard = ({ orderData }: OrderTotalProps) => {
  return (
    <Card backgroundColor="gallery" marginBottom={theme.spacing.large} padding="small">
      <Flex justifyContent="space-between">
        <Flex>
          <Image alt="a picture of an eero router" height="35" quality={75} src={'/eero.png'} width="48" />
          <ImagePaddingWrapper>
            <Typography as="p" variant="speakUp">
              {convertMbpsToGbps(orderData?.plan?.downstreamSpeedInMbps || 0)}
            </Typography>
            <Typography as="p" variant="whisper">
              {orderData?.plan?.displayName}
            </Typography>
            <Typography as="p" variant="whisper">
              {orderData?.plan.contractDurationText}
            </Typography>
            <Typography as="p" variant="whisper">
              Standard Wi-Fi
            </Typography>
          </ImagePaddingWrapper>
        </Flex>
        <Typography as="p" variant="whisper">
          £{orderData?.plan?.monthlyPrice}
        </Typography>
      </Flex>

      <Separator colour="alto" height="2px" marginBottom={theme.spacing.small} marginTop={theme.spacing.small} />

      <Typography as="p" textAlign="right" variant="speakUp">
        First month's payment
      </Typography>
      <Typography as="p" textAlign="right" variant="speakUp">
        £{orderData?.plan?.upfrontPrice}
      </Typography>
      <Typography as="p" variant="whisper">
        First month will be charged on the Go Live date
      </Typography>

      <Separator colour="alto" height="2px" marginBottom={theme.spacing.small} marginTop={theme.spacing.small} />

      <Typography as="p" textAlign="right" variant="speakUp">
        Ongoing monthly payment
      </Typography>
      <Typography as="p" textAlign="right" variant="speakUp">
        £{orderData?.plan?.monthlyPrice}
      </Typography>
    </Card>
  )
}

export default OrderTotalCard
